<template>
  <div class="flex-1 max-w-[552px] min-h-[calc(var(--app-height))] mx-auto">
    <form ref="form" @submit.prevent="submit">
      <div class="py-0 flex flex-col justify-center items-start w-full">
        <h1 class="text-[2rem] leading-[2.5rem] font-black text-[#433D31] tracking-[-0.03em]">
          Create New Password
        </h1>
        <p class="text-[1rem] leading-[1.5rem] font-semibold text-[#433D31] pt-[8px]">
          Your password must be different from your previous ones
        </p>
        <div class="pt-[40px] w-full">
          <PasswordInput
            v-model="newPassword"
            label="New Password"
            labelClasses="text-[#191817] text-[0.875rem] leading-[1.25rem] font-semibold pb-[4px]"
            placeholder="Enter Password"
            inputClasses="text-[#191817] text-[1rem] leading-[1.5rem] font-normal"
          />
        </div>

        <div class="w-full pt-[12px]">
          <PasswordConditions
            :has-eight-characters="hasEightCharacters"
            :has-one-lower-case="hasOneLowerCase"
            :has-one-upper-case="hasOneUpperCase"
            :has-one-number="hasOneNumber"
            :has-one-symbol="hasOneSymbol"
          />
        </div>

        <div class="pt-[40px] w-full">
          <PasswordInput
            v-model="confirmPassword"
            label="Confirm New Password"
            labelClasses="text-[#191817] text-[0.875rem] leading-[1.25rem] font-semibold pb-[4px]"
            placeholder="Enter Password"
            inputClasses="text-[#191817] text-[1rem] leading-[1.5rem] font-normal"
          />
          <div
            v-if="passwordsDoNotMatch"
            class="text-[#D92D20] text-[0.875rem] leading-[1.25rem] font-normal pt-[4px]"
          >
            Passwords do not match
          </div>
        </div>

        <div class="mt-[24px] w-full">
          <BaseButton
            solid-classes="h-[56px] bg-[#42362B] border-0 !rounded-[100px] text-white text-[1rem] leading-[1.5rem] font-bold items-center"
            disabled-classes="disabled:bg-[#C3C2C1] disabled:border-[#C3C2C1] disabled:cursor-not-allowed"
            full-width
            :disabled="!canSave"
            @click="submit"
          >
            {{ isLoading ? 'Loading...' : 'Create Password' }}
          </BaseButton>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import BaseButton from '@/components/design/BaseButton.vue';
import PasswordInput from '@/components/design/PasswordInput.vue';
import PasswordConditions from '@/components/common/PasswordConditions.vue';
import { mapState } from 'vuex';

export default {
  components: {
    BaseButton,
    PasswordInput,
    PasswordConditions,
  },

  data() {
    return {
      newPassword: '',
      confirmPassword: '',
    };
  },
  computed: {
    ...mapState('forgotCredentials', ['isLoading', 'email', 'forgotPasswordOtp']),
    password() {
      return this.newPassword;
    },

    hasEightCharacters() {
      return this.password.length >= 8;
    },

    hasOneUpperCase() {
      return /[A-Z]/.test(this.password);
    },

    hasOneLowerCase() {
      return /[a-z]/.test(this.password);
    },

    hasOneNumber() {
      return /\d/.test(this.password);
    },

    hasOneSymbol() {
      return /[^a-zA-Z0-9\s]/.test(this.password);
    },

    passwordsDoNotMatch() {
      if (!this.password || !this.confirmPassword) {
        return false;
      }
      return this.password !== this.confirmPassword;
    },

    canSave() {
      return (
        this.hasEightCharacters &&
        this.hasOneUpperCase &&
        this.hasOneLowerCase &&
        this.hasOneNumber &&
        this.hasOneSymbol &&
        this.password &&
        this.confirmPassword &&
        !this.passwordsDoNotMatch
      );
    },
  },
  methods: {
    async submit() {
      try {
        await this.$store.dispatch('forgotCredentials/resetPassword', {
          email: this.email,
          password: this.newPassword,
          otp: this.forgotPasswordOtp,
        });
        this.$emit('next');
      } catch (e) {
        console.error('Error resetting password:', e);
      }
    },
  },
};
</script>
